<template>
  <tr class="bg-light desplegable-inferior" data-toggle="collapse" :data-target="`[data-collapse='${collapse}']`" role="button">
    <th class="bg-light" :colspan="total">
      <div class="d-flex align-items-center pr-3 position-sticky cabecera-objetivo">
        <i class="fa-solid fa-caret-right fa-fw mr-1"></i>
        <span>
          <slot></slot>
        </span>
      </div>
    </th>
  </tr>
</template>

<style scoped>
.cabecera-objetivo {
  max-width: calc(100vw - 1rem);
  left: 0;
}
</style>

<script>
export default {
  name: "cabecera-objetivo",
  props: ["collapse", "total"],
};
</script>